

    
<template>
  <div class="appraise">

    <div class="copy" @click="copy()">
      <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
        y="0px" viewBox="0 0 19.2 20.6" style="enable-background:new 0 0 19.2 20.6;" xml:space="preserve">

        <g>
          <path class="st0" d="M9.1,17.9l-2.2,0.6c-0.5,0.1-1,0.1-1.4-0.2c-0.5-0.3-0.8-0.7-0.9-1.2L2.1,7.5C1.8,6.4,2.4,5.3,3.4,5l2-0.5
		c0.5-0.1,0.8-0.7,0.7-1.2C5.9,2.7,5.4,2.4,4.9,2.5l-2,0.5C0.8,3.7-0.4,5.8,0.1,8l2.5,9.7c0.3,1,0.9,1.9,1.9,2.5
		c0.6,0.3,1.3,0.5,1.9,0.5c0.3,0,0.7,0,1-0.1l2.2-0.6c0.5-0.1,0.8-0.7,0.7-1.2C10.2,18.1,9.7,17.8,9.1,17.9z" />
          <path class="st0" d="M14.6,5h4.5l-5-5v4.5C14.2,4.8,14.4,5,14.6,5z" />
          <path class="st0"
            d="M12.2,4V0h-2c-1.7,0-3,1.3-3,3v10c0,1.7,1.3,3,3,3h6c1.7,0,3-1.3,3-3V7h-4C13.5,7,12.2,5.7,12.2,4z" />
        </g>
      </svg>
      {{ $t('m.article.copy') }}
    </div>
    <transition name="fade">
      <div class="alert-box" v-if="showAlertBox">

        <div class="innerbox">
          <div class="li"> <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 22 22" style="
                  enable-background: new 0 0 22 22;
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  fill: #77c64b;
                  width: 18px;
                " xml:space="preserve">
              <path class="st0"
                d="M11,0C4.9,0,0,4.9,0,11c0,6.1,4.9,11,11,11s11-4.9,11-11C22,4.9,17.1,0,11,0z M15.8,10L11,14.8
                                                                            	c0,0-0.1,0.1-0.1,0.1c-0.3,0.3-0.7,0.5-1.1,0.5c-0.4,0-0.8-0.2-1.1-0.5c0,0-0.1-0.1-0.1-0.1l-2.5-2.5c-0.6-0.6-0.6-1.6,0-2.2
                                                                            	c0.6-0.6,1.6-0.6,2.2,0l1.5,1.5l3.8-3.8c0.6-0.6,1.6-0.6,2.2,0C16.4,8.4,16.4,9.4,15.8,10z" />
            </svg>  {{ $t('m.article.copysuccess') }}</div>

        </div>

      </div>
    </transition>
  </div>
</template>
 
<script>
//此页为通用页头
export default {
  data() {
    return {
      showAlertBox: false,
      timer: null
    };
  },
  methods: {
    copyText(value) {
      return new Promise((resolve) => {
        var input = document.createElement("input"); // js创建一个input输入框
        input.value = value; // 将需要复制的文本赋值到创建的input输入框中
        document.body.appendChild(input); // 将输入框暂时创建到实例里面
        input.select(); // 选中输入框中的内容
        document.execCommand("Copy"); // 执行复制操作
        document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
        resolve();
      });
    },
    copy() {
      const value = window.document.location.href;
      this.copyText(value);
      this.showAlertBox = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.showAlertBox = false;
      }, 2000);
    },
  },
  created() { },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/appraise.scss";
</style>